import styled from "styled-components";
import {RegisterButtonDefaultBox} from "./register-button.default.box";

export const RegisterButtonSiBox = styled(RegisterButtonDefaultBox)`
  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    background-color: ${props => props.theme.colors.brandPrimaryContrast};
    color: ${props => props.theme.colors.brandPrimary};
   
    @media ${({theme}) => theme.mediaQuery.lAndAbove} {
      &:hover {
        background-color: ${props => props.theme.colors.brandPrimary};
        color: ${props => props.theme.colors.brandPrimaryContrast};
        border: 2px solid ${props => props.theme.colors.brandPrimaryContrast};
      }
    }
    
  }
  
`